<header class="tw:inline-block tw:w-full">
    <lib-heading-header><ng-content></ng-content></lib-heading-header>
    <ng-content select="dv-bisher-x"></ng-content>
    <hr class="tw:mb-[5rem] tw:border-t-[#333] tw:h-[.1rem] tw:mt-2" />
</header>
